import { Component, OnInit, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-edit-component',
  templateUrl: './add-edit-component.component.html',
  styleUrls: ['./add-edit-component.component.css']
})
export class AddEditComponentComponent implements OnInit {

  component: any = {};
  tempKey: any = {};

  constructor(private httpClient: HttpClient, public dialogRef: MatDialogRef<AddEditComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.component.id = this.data.id ? this.data.id : 0
    this.component.DataKey = this.data.dataKey ? this.data.dataKey : ''
    this.component.Name = this.data.name ? this.data.name : ''
    this.component.title = this.data.title ? this.data.title : ''

    if (this.data.CategoryId || this.data.categoryId) {
      this.component.Category = this.data.CategoryId ? this.data.CategoryId : null
    }
    if (this.data.category || this.data.categoryId) {
      this.component.Category = this.data.category ? this.data.category : this.data.categoryId
    }
  }



  save(form) {
    if (form.invalid)
      return

    const data = {
      id: this.component.id,
      Name: this.component.Name,
      DataKey: this.component.DataKey,
      title: this.component.title|| '',
      CategoryId: this.component.Category,
      TokenId: 'no token',
    }

    this.httpClient.post('/Components/SaveComponent', data).subscribe((res: any) => {
      this.dialogRef.close('done');
    });

  }

  close() {
    this.dialogRef.close();
  }



}